import React from "react";

export type CategoryType = "PROJECT" | "ENTERTAINMENT" | "RANDOM" | "IMAGE";

export type BaseItem = {
id: number;
category: CategoryType;
author: string;
handle: string;
timestamp: string;
content: string;
stats: {
    comments: number;
    retweets: number;
    likes: number;
    views: string;
};
};

export type ProjectItem = BaseItem & {
type: "project";
projectData: {
    name: string;
    icon: React.ReactNode;
    playable: boolean;
    path?: string;
    mode: "playable" | "video";
    banner_image?: string;
};
videoUrl?: string;
imageUrl?: string;
};

export type VideoItem = BaseItem & {
type: "video";
videoUrl: string;
};

export type ImageItem = BaseItem & {
type: "image";
imageUrl: string;
};

export type TextItem = BaseItem & {
type: "text";
};

export type FeedItem = ProjectItem | VideoItem | ImageItem | TextItem;

export const feedItems: FeedItem[] = [

{
    id: 81,
    type: "video",
    category: "RANDOM",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "[*]",
    videoUrl: "/videos/Walking_With_Cat.mp4",
    stats: {
        comments: 1,
        retweets: 3,
        likes: 130,
        views: "75K"
    }
},

{
    id: 80,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2021_Semarang_Gondang_Timur",
    imageUrl: "cat/2021_Semarang_Gondang_Timur.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 79,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2022_Sumatera_Utara_Kabanjahe",
    imageUrl: "cat/2022_Sumatera_Utara_Kabanjahe.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 78,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2023_Jogja_Gunung_Sari",
    imageUrl: "cat/2023_Jogja_Gunung_Sari.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 77,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2023_Jogja_Jombor",
    imageUrl: "cat/2023_Jogja_Jombor.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 76,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2023_Jogja_Merapi",
    imageUrl: "cat/2023_Jogja_Merapi.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 75,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2023_Jogja_Parangtriris",
    imageUrl: "cat/2023_Jogja_Parangtriris.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 74,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2023_Jogja_Wates",
    imageUrl: "cat/2023_Jogja_Wates.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 73,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2023_Semarang_Bukit_Diponegoro",
    imageUrl: "cat/2023_Semarang_Bukit_Diponegoro.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 72,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2023_Semarang_Bundaran_Undip",
    imageUrl: "cat/2023_Semarang_Bundaran_Undip.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 71,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Jakarta_Cilandak_Timur",
    imageUrl: "cat/2024_Jakarta_Cilandak_Timur.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 70,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Jakarta_Menteng",
    imageUrl: "cat/2024_Jakarta_Menteng.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 69,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Jakarta_Ragunan",
    imageUrl: "cat/2024_Jakarta_Ragunan.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 68,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Jambi_Mayang",
    imageUrl: "cat/2024_Jambi_Mayang.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 67,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Jambi_Muaro_Jambi",
    imageUrl: "cat/2024_Jambi_Muaro_Jambi.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 66,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Jambi_Nusa_Indah",
    imageUrl: "cat/2024_Jambi_Nusa_Indah.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 65,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Lampung_Tanjung_Karang",
    imageUrl: "cat/2024_Lampung_Tanjung_Karang.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 64,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Lampung_Terbanggi_Besar",
    imageUrl: "cat/2024_Lampung_Terbanggi_Besar.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 63,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Semarang_Banjarsari",
    imageUrl: "cat/2024_Semarang_Banjarsari.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 62,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2024_Tangerang_Karawaci",
    imageUrl: "cat/2024_Tangerang_Karawaci.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 61,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2025_Bogor_Megamendung",
    imageUrl: "cat/2025_Bogor_Megamendung.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 60,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2025_Jakarta_Cilandak_Timur",
    imageUrl: "cat/2025_Jakarta_Cilandak_Timur.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 59,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2025_Jakarta_Dukuh_Atas",
    imageUrl: "cat/2025_Jakarta_Dukuh_Atas.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 58,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2025_Jakarta_Jagakarsa",
    imageUrl: "cat/2025_Jakarta_Jagakarsa.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 57,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2025_Jakarta_Lebak_Bulus",
    imageUrl: "cat/2025_Jakarta_Lebak_Bulus.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 56,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2025_Jakarta_Tebet",
    imageUrl: "cat/2025_Jakarta_Tebet.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 55,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2026_Jambi_Kenali",
    imageUrl: "cat/2026_Jambi_Kenali.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 54,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2026_Jambi_Tugu_Juang",
    imageUrl: "cat/2026_Jambi_Tugu_Juang.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 53,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2026_Tangerang_Serpong",
    imageUrl: "cat/2026_Tangerang_Serpong.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},

];